export default "__VITE_ASSET__BCd3n7P2__"